import { AutogenModelCarrierAction, AutogenRowCarrierAction } from "./autogen/AutogenModelCarrierAction";

export class ModelCarrierAction extends AutogenModelCarrierAction<RowCarrierAction> {
	constructor() {
		super(RowCarrierAction);
	}
}

export class RowCarrierAction extends AutogenRowCarrierAction {
}